import '@fontsource-variable/public-sans'
import './app.css'
import App from './App.svelte'
import { mount } from 'svelte'
import { attemptRefresh, fetchMe } from './lib/auth/login-flow.js'
import { setSession } from './lib/auth/session.js'

const target = document.getElementById('app')
if (!target) throw new Error('root element #app missing from index.html')

// Render an inline skeleton immediately so the page doesn't stay blank while
// boot's async refresh runs. Replaced by mount(App) once the refresh resolves.
target.innerHTML =
  '<div style="display:flex;align-items:center;justify-content:center;min-height:100vh;font:14px system-ui;color:var(--muted)">Loading…</div>'

async function boot(mountTarget: HTMLElement): Promise<void> {
  try {
    const token = await attemptRefresh()
    if (token) {
      try {
        const me = await fetchMe(token)
        setSession(token, me)
      } catch {
        // If /me fails, leave unauthenticated.
      }
    }
  } catch {
    // Refresh network failure - proceed to login.
  }
  // Replace skeleton with the mounted app.
  mountTarget.innerHTML = ''
  mount(App, { target: mountTarget })
}

void boot(target)
